// extracted by mini-css-extract-plugin
module.exports = {"legalTextWrapper":"LegalText_legalTextWrapper__aRZKY","legalText":"LegalText_legalText__vp1ZK"};